import { OrganizationResponse } from 'src/types/rest/tenant';

export const getOrganizationInfo = (
  organization: OrganizationResponse | null,
) => {
  if (organization === null) return '';
  // Names are not unique, so the customer number is also being displayed
  return `${organization.name} (#${organization.customerNumber})`;
};
